import httpClient from '@/libs/http-client'

export function getCardInfo (serviceType) {
  const url = `/card/get_info`

  return httpClient.post(url, { serviceType }).then(response => {
    return response.data.result
  })
}

export function getPaymentHistory () {
  const url = `/ba/payment/get_payment_history`

  return httpClient.get(url).then(response => {
    return response.data.result
  })
}

export function registerCardExisting (params) {
  const url = `/card/register_existing`

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function registerSuccess (params) {
  const url = '/card/register_success'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function registerSuccessToss (params) {
  const url = '/card/register_success_toss'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function registerFailed (params) {
  const url = '/card/register_fail'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function saveReportPayment (params) {
  const url = '/ai/journeymap/save_payment'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}
